import { z } from "zod";

export const LEAD_SEGMENTS = ["pre_sales", "battery_upsell"] as const;

export type LeadSegmentT = (typeof LEAD_SEGMENTS)[number];

export const INCLUDE_BATTERY_UPSELL_PARAM = "include_battery_upsell";

export const BATTERY_UPSELL_PARAMS = { [INCLUDE_BATTERY_UPSELL_PARAM]: true } as const;

export const BATTERY_UPSELL_SEGMENT: LeadSegmentT = "battery_upsell";

export const LeadSegmentSchema = z
  .enum(LEAD_SEGMENTS)
  .nullish()
  .catch("pre_sales")
  .transform((value): LeadSegmentT => value ?? "pre_sales");
